import React from 'react';
import { ResponsiveContainer} from './Home.styles';
import HeroSection from './HeroSection/HeroSection';
import MissionHighlights from './MissionHighlights/MissionHighlights';
// import KeyFeatures from './KeyFeatures/KeyFeatures';
import Testimonial from './Testimonial/Testimonial';
import SpiritualHope from './SpiritualHope/SpiritualHope';

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <ResponsiveContainer>
     
        <MissionHighlights />
        
        <Testimonial />
        
        <SpiritualHope />
        {/* Remaining Homepage Content */}
      </ResponsiveContainer>
    </>
  );
};

export default Home;